// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"content_content-wrapper__3TxI8"};